const e = {
  name: "ShopperBagAction",
  dimensions: { width: 34, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 34 40" style="enable-background:new 0 0 34 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M28,26.1V8h-7V7c0-3.9-3.1-7-7-7S7,3.1,7,7v1H0v32h27c3.9,0,7-3.1,7-7C34,29.5,31.4,26.6,28,26.1z M14,2
			c2.8,0,5,2.2,5,5v1H9V7C9,4.2,11.2,2,14,2z M7,15h2v-5h10v5h2v-5h5v16.1c-3.4,0.5-6,3.4-6,6.9c0,2,0.8,3.7,2.1,5H2V10h5V15z
			 M27,38c-2.8,0-5-2.2-5-5s2.2-5,5-5c2.8,0,5,2.2,5,5S29.8,38,27,38z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as ShopperBagAction
};
